<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>

<div class="subBlockContent" id="newletteritems">
  <child-header [title]="newsletterView?.newsLetter.title"  (closeEvent)="close()" titleDownload="Download Excel" [showDownload]="loadContent" (downloadEvent)="exportExcelForCatalogue(newsletterView?.newsLetter.news_id)" ></child-header>
  <div class="child-body">
    <div class="inner-subBlock-wrapper">
      <div *ngIf="errorMsg">
        <h1>INVALID NEWSLETTER ID</h1>
        <div class="button button-red button-large" (click)="close()">GO BACK TO NEWSLETTER LIST</div>
      </div>
      <div id="newsLetter-view" *ngIf="newsletterView">
        <div id="newsletterItems">
          <div>
            <!-- <div class="top-bottom-space">
              <div id="btnBack" class="button button-dark button-small" (click)="close()">BACK</div>
            </div> -->
            <div>
              <div id="newsletterView" class="{{newsletterView?.newsLetter.color}} clearfix" *ngIf="!errorMsg && newsletterView?.newsLetter">
                <!-- <div id="{{newsletterView?.newsLetter.news_id}}" class="cms-head">
                  <span class="page-title-wrapper page-title-position">{{newsletterView?.newsLetter.title}}</span>
                  <span id="catDownloadButton" class="basic-icon download-icon" (click)="exportExcelForCatalogue(newsletterView?.newsLetter.news_id)"></span>
                  <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
                </div> -->
                <div class="page-title-description">
                  {{newsletterView?.newsLetter.description}}
                </div>
                <div class="top-divider"></div>
                
                <!-- #cmsNewsletterHeader end -->
                <div id="cmsSectionList" class="clearfix" [innerHTML]="toHTML(newsletterView?.finalHtml) | sanitizeHtml" appAppMotationObserverv2 (innerHtmlRendered)="renderedCb(newsId, newsletterView?.newsLetter.title)" routeTransformerv2>
                </div>
                <!-- #cmsSectionList end -->
              </div>
              <!-- #newsletterView end -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
</div>

<router-outlet></router-outlet>